export const INCREMENT = 'INCREMENT';
export const CHECKOUTDATA = 'CHECKOUTDATA';
export const PAYMENTSESSION = 'PAYMENTSESSION';
export const PAYMENTPUBLICSESSION = 'PAYMENTPUBLICSESSION';
export const PAYMENTOPTIONS ='PAYMENTOPTIONS';
export const PAYMENTTYPE = 'PAYMENTTYPE';